import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ErrorsInterface } from '../errors/errors-interface';
import { Observable } from 'rxjs';
import { PartnerUser } from './definitions/partner-user-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface PartnerUserUpdateResponse {
  partner: {
    update: {
      output: PartnerUser;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class PartnerUserUpdateService {
  constructor(private apollo: Apollo) {}

  update(
    userId: string,
    roles: Array<string>,
    name: string,
    email: string,
    notificationMissingDocuments: boolean,
    notificationTaskCompleted: boolean,
    mutation: DocumentNode
  ): Observable<FetchResult<any>> {
    return this.apollo.mutate<PartnerUserUpdateResponse>({
      mutation: mutation,
      variables: {
        id: userId,
        roles: roles,
        name: name,
        email: email,
        notificationMissingDocuments: notificationMissingDocuments,
        notificationTaskCompleted: notificationTaskCompleted
      },
    });
  }
}
